import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { commonConstant } from '../../common';
import './CartPromotion.scss';
import { createCartInstallment, createCartPublic, getCart, getCartId, getCartPublic, INSTALLMENT_TYPE, PAYMENT_OPTION } from '../../services/promotion/utils.service';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCartData } from '../../actions/cartAction';
import LoadingOverlay from 'react-loading-overlay';
import { SESSION_KEY } from '../../common/commonConstant';
import { liffGetProfile } from '../../services/promotion/auth.service';

const CartIcon = (props) => {
  const [cartCount, setCartCount] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchCustData() {
      try {
        let customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
        //as current Redux is a sync call, we required to check isFOAEmpty 
        if (props?.isFOAEmpty) {
          customerFOA = null;
        }
        const urlParams = new URLSearchParams(location.search);
        const guid = sessionStorage.getItem('guid');

        const cart = !customerFOA ? await props.getCartData("FULL", getCartId(urlParams.get(SESSION_KEY.isInstallment))) : guid
          ? await getCartPublic(guid) : await createCartPublic();
        if (Array.isArray(cart)) {
          let isInstallment = INSTALLMENT_TYPE.FALSE;
          if (cart.length && (cart[0]?.paymentType === PAYMENT_OPTION.ZIPP || cart[0]?.paymentType === PAYMENT_OPTION.ZIPP_ABO)) {
            sessionStorage.setItem(SESSION_KEY.zippCartId, cart[0].id);
            isInstallment = INSTALLMENT_TYPE.TRUE;
            if (!sessionStorage.getItem(SESSION_KEY.pifCartId)) {
              setLoading(true);
              const { userId } = await liffGetProfile();
              const cartData = await createCartInstallment(userId, false);
              sessionStorage.setItem(SESSION_KEY.pifCartId, cartData.id);
              setLoading(false);
            }
          } else if (cart.length && cart[0]?.paymentType === PAYMENT_OPTION.PIF) {
            sessionStorage.setItem(SESSION_KEY.pifCartId, cart[0].id);
            isInstallment = INSTALLMENT_TYPE.FALSE;
          }
          urlParams.set('isInstallment', isInstallment);
          history.push({ search: urlParams.toString() })
          const count = cart[0].entries.reduce((total, item) =>
            total + (item.kitEntryCode || item.isGiveAway ? 0 : item.quantity || 0),
            0,
          );
          setCartCount(count);
        }
      } catch (e) {
        setLoading(false);
      }
    }
    fetchCustData();
  }, []);

  const goToCart = () => {
    history.push({ pathname: commonConstant.pathCartPromotion, search: location.search });
  }

  return (<div>
    <LoadingOverlay
      text="Loading"
      spinner
      active={props.loading || loading}
      styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
    />
    <div className="icon-button" onClick={goToCart}>
      <img src="/images/promotion/iconButton.svg" />
      <span className="circle-notification">
        <span className="notification-text">{cartCount > 99 ? `+99` : cartCount}</span>
      </span>
    </div>
  </div>)

};

const mapStateToProps = (state) => {
  return {
    data: state.cartApi.data,
    loading: state.cartApi.loading,
    error: state.cartApi.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartData: (fields, cartId) => dispatch(getCartData(fields, cartId)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon);